export const getMarriageNOCsSelector = state => Object.values(state.marriageNoc.details);

export const getMarriageNOCSelector = (state, uuid) => state?.marriageNoc?.details?.[uuid];

export const getRelatedNOCSelector = (state, uuid) => state?.marriageNoc?.related?.[uuid];
